import { useMutation, useQueryClient } from '@tanstack/react-query';

import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const postTogglePinLiveEvent = async ({ entityId, action }) => {
  const payload = {
    entity_type: 'LIVE',
    entity_id: entityId,
  };

  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const route =
    action === 'pin' ? API_ROUTES.PIN_ENTITY : API_ROUTES.UNPIN_ENTITY;

  const { data } = await PrivateAdminPanelInstance.post(route, payload);
  return data;
};

export const useTogglePinLiveEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['TOGGLE_PIN_EVENT'],
    mutationFn: postTogglePinLiveEvent,

    onMutate: async ({ entityId, action, sportId }) => {
      await queryClient.cancelQueries(['GET_LIVE_EVENT_ENTITIES', sportId]);

      const previous = queryClient.getQueryData([
        'GET_LIVE_EVENT_ENTITIES',
        sportId,
      ]);

      queryClient.setQueryData(['GET_LIVE_EVENT_ENTITIES', sportId], (old) => {
        if (!old) return old;

        return old.map((league) => {
          const events = league.events.map((event) => {
            if (event.entity_id !== entityId) return event;

            if (action === 'pin') {
              return {
                ...event,
                pinned_order: event.pinned_order || '1',
              };
            } else {
              return {
                ...event,
                pinned_order: undefined,
              };
            }
          });

          return { ...league, events };
        });
      });

      return { previous, sportId };
    },

    onError: (_err, _vars, ctx) => {
      if (ctx?.previous) {
        queryClient.setQueryData(
          ['GET_LIVE_EVENT_ENTITIES', ctx.sportId],
          ctx.previous
        );
      }
    },

    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries([
        'GET_LIVE_EVENT_ENTITIES',
        variables.sportId,
      ]);
    },
  });
};

